const STEPS = [1, 2, 3, 4, 5] as const;

type ReadinessSliderProps = {
  value: number;
  onChange: (value: number) => void;
  variant?: "default" | "hero";
};

export const ReadinessSlider = ({ value, onChange, variant = "default" }: ReadinessSliderProps) => {
  const hero = variant === "hero";

  return (
    <div>
      <p className={`text-[15px] text-neutral-500 ${hero ? "text-center" : ""}`}>
        Quão pronto você se sente?
      </p>
      {hero && (
        <p className="mt-2.5 text-center text-[56px] font-extrabold leading-none tracking-[-0.04em] text-blue-600">
          {value}
          <span className="text-[22px] font-semibold text-neutral-500"> / 5</span>
        </p>
      )}
      <div className={hero ? "mt-3" : "mt-5"}>
        <div className="relative h-5">
          <div className="absolute inset-x-1 top-1/2 h-[3px] -translate-y-1/2 rounded-full bg-neutral-200" />
          <div
            className="absolute left-1 top-1/2 h-[3px] -translate-y-1/2 rounded-full bg-blue-500"
            style={{ width: `calc(${((value - 1) / 4) * 100}% - 4px)` }}
          />
          <div className="relative flex justify-between">
            {STEPS.map((step) => {
              const filled = step <= value;
              const current = step === value;
              return (
                <button
                  key={step}
                  type="button"
                  aria-label={`Pronto ${step}`}
                  aria-pressed={current}
                  onClick={() => onChange(step)}
                  className={`rounded-full border-2 transition-all ${
                    filled ? "border-blue-500 bg-blue-500" : "border-neutral-200 bg-white"
                  } ${current ? "h-5 w-5" : "mt-0.5 h-3.5 w-3.5"}`}
                />
              );
            })}
          </div>
        </div>
        {!hero && (
          <>
            <div className="mt-2 flex justify-between text-xs text-neutral-500">
              {STEPS.map((step) => (
                <span key={step} className="w-5 text-center">
                  {step}
                </span>
              ))}
            </div>
            <p className="mt-2 text-center text-sm font-medium text-blue-600">{value} de 5</p>
          </>
        )}
      </div>
    </div>
  );
};
